// extracted by mini-css-extract-plugin
export default {"shared":"\"../shared.module.css\"","lg":"992px","container":"RemoveAddressModal_container__yjUZC","buttonsContainer":"RemoveAddressModal_buttonsContainer__zP0z2"};